import React, { useState } from 'react';
import { SlidersHorizontal, Search } from 'lucide-react';
import { products, categories } from '../data/products';
import ProductCard from '../components/ProductCard';
import './Collection.css';

function Collection({ addToCart }) {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortBy, setSortBy] = useState('default');
  const [searchQuery, setSearchQuery] = useState('');

  let filteredProducts = selectedCategory === 'all'
    ? products
    : products.filter(p => p.category === selectedCategory);

  if (searchQuery) {
    filteredProducts = filteredProducts.filter(p =>
      p.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }

  if (sortBy === 'price-low') {
    filteredProducts = [...filteredProducts].sort((a, b) => a.price - b.price);
  } else if (sortBy === 'price-high') {
    filteredProducts = [...filteredProducts].sort((a, b) => b.price - a.price);
  } else if (sortBy === 'rating') {
    filteredProducts = [...filteredProducts].sort((a, b) => b.rating - a.rating);
  }

  return (
    <div className="collection">
      {/* Page Header */}
      <section className="collection-header">
        <div className="collection-header-content">
          <h1>Our Collection</h1>
          <p>Ethically Sourced, Authentically Madinah</p>
          <div className="breadcrumb">
            <span>Home</span> <span>/</span> <span className="active">Collection</span>
          </div>
        </div>
      </section>

      {/* Toolbar */}
      <section className="collection-toolbar">
        <div className="toolbar-container">
          <div className="search-box">
            <Search size={18} />
            <input
              type="text"
              placeholder="Search products..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="sort-box">
            <SlidersHorizontal size={18} />
            <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
              <option value="default">Sort by: Default</option>
              <option value="price-low">Price: Low to High</option>
              <option value="price-high">Price: High to Low</option>
              <option value="rating">Top Rated</option>
            </select>
          </div>
        </div>
      </section>

      {/* Layout: Sidebar + Products */}
      <section className="collection-layout">
        {/* Sidebar */}
        <aside className="collection-sidebar">
          <div className="sidebar-section">
            <h3>Categories</h3>
            <ul className="category-list">
              {categories.map(cat => (
                <li
                  key={cat.id}
                  className={selectedCategory === cat.id ? 'active' : ''}
                  onClick={() => setSelectedCategory(cat.id)}
                >
                  <span className="cat-icon">{cat.icon}</span>
                  <span className="cat-name">{cat.name}</span>
                  <span className="cat-count">
                    {cat.id === 'all' ? products.length : products.filter(p => p.category === cat.id).length}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="sidebar-section">
            <h3>Price Range</h3>
            <div className="price-range">
              <div className="price-track">
                <div className="price-fill"></div>
              </div>
              <div className="price-labels">
                <span>45 SAR</span>
                <span>250 SAR</span>
              </div>
            </div>
          </div>

          <div className="sidebar-section">
            <h3>Filter By</h3>
            <label className="filter-checkbox">
              <input type="checkbox" defaultChecked /> Halal Certified
            </label>
            <label className="filter-checkbox">
              <input type="checkbox" /> On Sale
            </label>
            <label className="filter-checkbox">
              <input type="checkbox" /> In Stock
            </label>
          </div>

          <div className="sidebar-promo">
            <h3>Free Shipping</h3>
            <p>On all orders over 500 SAR</p>
            <span>🌐</span>
          </div>
        </aside>

        {/* Products */}
        <div className="collection-products">
          <div className="products-info">
            <span>Showing {filteredProducts.length} products</span>
          </div>

          {filteredProducts.length === 0 ? (
            <div className="no-products">
              <span>🔍</span>
              <h3>No products found</h3>
              <p>Try adjusting your filters or search</p>
            </div>
          ) : (
            <div className="products-grid">
              {filteredProducts.map(product => (
                <ProductCard key={product.id} product={product} addToCart={addToCart} />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default Collection;
